// The board STAT STRIP (brief §5.2): open items / needs a decision / exited this week / next sweep.
// Every figure is lifted from the projection (G-182): open items is the whole-board `countsByState`
// sum (never the filtered slice), the decision count is `needsDecisionCount`, and the exited note
// derives from the projection's declared exit states — nothing here is hand-kept copy.

import { Dot, StatCard, StatStrip } from '../../../primitives.tsx';
import type { WorkBoardProjection } from '../../projections.ts';
import { exitNote, openItemsCount } from '../board-model.ts';

export interface BoardStatsProps {
  readonly board: WorkBoardProjection;
}

/** The four whole-board stats above the columns. */
export function BoardStats({ board }: BoardStatsProps): React.JSX.Element {
  return (
    <StatStrip>
      <StatCard
        label="Open items"
        value={openItemsCount(board.countsByState)}
        note="on the board"
      />
      <StatCard
        label="Needs a decision"
        value={
          <span className="inline-flex items-center gap-2">
            <Dot tone="attention" />
            {board.needsDecisionCount}
          </span>
        }
        note="frozen at a gate"
      />
      <StatCard label="Exited this week" value={board.exitedThisWeek} note={exitNote(board)} />
      <StatCard
        label="Next sweep"
        value={<span className="text-xl">{board.nextDueAt ?? '—'}</span>}
        note="whole board"
      />
    </StatStrip>
  );
}
